import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom"
import { ToastContent, toast } from "react-toastify";
import { handleLoader } from "redux/counterSlice";
import { addRoleData, getRoleById, roleUpdate } from "services/roleService";

const AddRole = () => {
    const permissions = useSelector((state: any) => state.persistent.role_permissions);
    const params = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm()
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fetchRoleData = async (id: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getRoleById(id)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }

            dispatch(handleLoader(false));
            setValue("role_name", result.name)
            setValue("description", result.description)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const onSubmit = async (data: { [x: string]: any }) => {
        const createBy = localStorage.getItem("username")
        dispatch(handleLoader(true));
        try {
            if (params.id === "add" && permissions.add) {
                let { result, error } = await addRoleData({ created_by: createBy!, role_name: data?.role_name, description: data?.description })
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                navigate("/admin/roles")
            } else if (params.id !== "add" && permissions.edit) {
                let { result, error } = await roleUpdate({ updated_by: createBy, role_id: params.id, ...data })
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                navigate("/admin/roles")
            }
            dispatch(handleLoader(false));
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    useEffect(() => {
        if (params.id !== "add") {
            fetchRoleData(params?.id?.toString() ?? "")
        }
    }, [])

    const getFormErrorMessage = (name: string) => {
        return errors[name] && <small className="p-error">{errors[name]?.message?.toString()}</small>
    }


    return (
        <main className="content-wrapper" >
            <div className='container-fluid p-4 user-group user-management-section'>
                <h4 className='mb-3'>{params.id !== "add" ? "Edit Role" : "Add Role"}</h4>
                <div className="user-group-card">
                    <div className="user-group-body">
                        <form onSubmit={handleSubmit(onSubmit)} className="group-form">
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Role Name<i>*</i></label>
                                    <div>
                                        <InputText className="form-control" {...register("role_name", { required: { value: true, message: "Role name is required" } })} placeholder="Role" />
                                    </div>
                                    {getFormErrorMessage("role_name")}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label"> Description<i>*</i></label>
                                    <div>
                                        <InputTextarea rows={6} className="form-control p-inputtext-lg" {...register("description", { required: { value: true, message: "Description is required" } })} placeholder="Add role description here..." />
                                    </div>
                                    {getFormErrorMessage("description")}
                                </div>
                            </div>

                            <div className="mt-2">
                                <Button className="outline-icon-btn mr-3" type="button" onClick={() => { navigate('/admin/roles') }}>Cancel</Button>
                                <Button className="outline-active-btn" type="submit">Save</Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default AddRole